import React, { useEffect, useState } from "react";
import "./Calculator.css";
import ShowInvestment from "./ShowInvestment";
import BarGraph from "./BarGraph";
import BarGraphCostOfDelay from "./BarGraphCostOfDelay";
import MaskedInput from "react-text-mask";
import { CommaSeprator, convertIntoLakh } from "../UtilityComponents/UtilityFunction";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import GoalCalc from "./Calc-Component/GoalCalc";
import CustomDropdown from "../UtilityComponents/CustomDropdown";
import { paymentFrequencyList } from "../UtilityComponents/constant";

const Calculator = (props) => {
    const [investmentAmount, setInvestmentAmount] = useState(10000);
    const [paymentType, setPaymentType] = useState("monthly");
    const [investmentPeriod, setInvestmentPeriod] = useState(10);
    const [maturity, setMaturity] = useState(15);
    const [interestRate, setInterestRate] = useState(8);
    const [showAmtInvt, setShowAmtInvt] = useState("");
    const [showAmtRet, setShowAmtRet] = useState("");
    const [showBar, setShowBar] = useState([]);
    const [error, setError] = useState("");
    const [err, setErr] = useState("");
    const [Year, setYear] = useState(false);

    /*cost of delay calculator*/
    const [targetAmount, setTargetAmount] = useState(10000);
    const [targetYear, setTargetYear] = useState(10);
    const [expectedReturn, setExpectedReturn] = useState(12);
    const [SIPValue, setSIPValue] = useState('');
    const [DelayMonth, setDelayMonth] = useState(12);
    const [DelayAmount, setDelayAmount] = useState(0);

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    function compoundInterestYear(amt, rate, period, investedPeriod) {
        let totalAmt = amt;

        for (let i = 0; i <= investedPeriod; i++) {
            let intAmt;
            if (i === 0) {
                intAmt = totalAmt * (rate / 100);
                totalAmt += intAmt;
            } else if (i < period) {
                intAmt = (totalAmt + amt) * (rate / 100);
                totalAmt += intAmt + amt;
            } else if (i > period) {
                for (let index = 0; index < investedPeriod - period; index++) {
                    intAmt = totalAmt * (rate / 100);
                    totalAmt += intAmt;
                }
                return totalAmt;
            }
        }
        return totalAmt;
    }

    function compoundInterestMonth(amt, rate, period, investedPeriod) {
        let totalAmt = amt;

        for (let i = 0; i <= investedPeriod; i++) {
            let intAmt;
            if (i === 0) {
                intAmt = totalAmt * (rate / 100);
                totalAmt += intAmt;
            } else if (i < period) {
                intAmt = (totalAmt + amt) * (rate / 100);
                totalAmt += intAmt + amt;
            } else if (i > period) {
                for (let index = 0; index < investedPeriod - period; index++) {
                    intAmt = totalAmt * (rate / 100);
                    totalAmt += intAmt;
                }
                return totalAmt;
            }
        }
        return totalAmt;
    }

    function compoundInterestMonthSmall(amt, rate, period) {
        let totalAmt = amt;

        for (let i = 0; i < period; i++) {
            let intAmt;
            if (i === 0) {
                intAmt = totalAmt * (rate / 100);
                totalAmt += intAmt;
            } else {
                intAmt = (totalAmt + amt) * (rate / 100);
                totalAmt += intAmt + amt;
            }
        }
        return totalAmt;
    }

    function compoundInterestYearSmall(amt, rate, period) {
        let totalAmt = amt;

        for (let i = 0; i < period; i++) {
            let intAmt;
            if (i === 0) {
                intAmt = totalAmt * (rate / 100);
                totalAmt += intAmt;
            } else {
                intAmt = (totalAmt + amt) * (rate / 100);
                totalAmt += intAmt + amt;
            }
        }
        return totalAmt;
    }

    useEffect(() => {
        if (+investmentPeriod > +maturity) {
            setError("Maturity Period should always be greater than or equal to Investment Period");
        }
        else {
            if (paymentType === "monthly") {
                if (investmentAmount < 1000 || investmentAmount > 200000) {
                    setErr("Amount should be between 1,000 to 2,00,000 monthly");
                }
                else {
                    setErr("")
                    let totalAmtInvt = investmentAmount * 12 * investmentPeriod;
                    setShowAmtInvt(totalAmtInvt);

                    let returnAmount;
                    returnAmount = Math.round(
                        compoundInterestMonth(
                            investmentAmount * 12,
                            interestRate,
                            investmentPeriod,
                            maturity
                        )
                    );
                   // setShowBar([]);
                    setShowAmtRet(returnAmount);
                }
            }

            if (paymentType === "yearly") {
                
                if (investmentAmount < 12000 || investmentAmount > 2400000) {
                    setErr("Amount should be between 12,000 to 24,00,000 yearly")
                }
                else {
                    setErr("");
                    
                    let totalAmtInvt = investmentAmount * investmentPeriod;
                    setShowAmtInvt(totalAmtInvt);

                    let returnYearAmount;
                    returnYearAmount = Math.round(
                        compoundInterestYear(
                            +investmentAmount,
                            interestRate,
                            investmentPeriod,
                            maturity
                        )
                    );
                    //setShowBar([]);
                    setShowAmtRet(returnYearAmount);
                }
            }

            if (paymentType === "halfyearly") {

                if (investmentAmount < 6000 || investmentAmount > 1200000) {
                    setErr("Amount should be between 6,000 to 12,00,000 half yearly")
                } else {
                    setErr("");
                    let totalAmtInvt = investmentAmount * 2 * investmentPeriod;
                    setShowAmtInvt(totalAmtInvt);

                    let returnYearAmount;
                    returnYearAmount = Math.round(
                        compoundInterestYear(
                            +investmentAmount * 2,
                            interestRate,
                            investmentPeriod,
                            maturity
                        )
                    );
                    //setShowBar([]);
                    setShowAmtRet(returnYearAmount);
                }
            }

            if (paymentType === "quarterly") {

                if (investmentAmount < 3000 || investmentAmount > 600000) {
                    setErr("Amount should be between 3,000 to 6,00,000 quarterly")
                } else {
                    setErr("");
                    let totalAmtInvt = investmentAmount * 4 * investmentPeriod;
                    setShowAmtInvt(totalAmtInvt);

                    let returnYearAmount;
                    returnYearAmount = Math.round(
                        compoundInterestYear(
                            +investmentAmount * 4,
                            interestRate,
                            investmentPeriod,
                            maturity
                        )
                    );
                    //setShowBar([]);
                    setShowAmtRet(returnYearAmount);
                }
            }

            setError("")
        }
    }, [investmentAmount, investmentPeriod, maturity, interestRate, paymentType]);

    useEffect(() => {

        if (showAmtInvt && showAmtRet) {
            let data = [];
            if (paymentType === "monthly") {
                if (maturity <= 5) {
                    for (let i = 2; i <= maturity; i += 2) {
                        data.push(i);
                    }

                    if (!data.includes(maturity)) {
                        data.push(+maturity);
                    }
                } else if (maturity <= 10) {
                    for (let i = 3; i <= maturity; i += 3) {
                        data.push(i);
                    }

                    if (!data.includes(maturity)) {
                        data.push(+maturity);
                    }
                } else if (maturity < 20) {
                    for (let i = 4; i <= maturity; i += 4) {
                        data.push(i);
                    }

                    if (!data.includes(maturity)) {
                        data.push(+maturity);
                    }
                } else if (maturity >= 20) {
                    for (let i = 5; i <= maturity; i += 5) {
                        data.push(i);
                    }

                    if (!data.includes(+maturity)) {
                        data.push(+maturity);
                    }
                }

                if (data.length > 5) {
                    let diff = data.length - 5;
                    for (let i = 0; i < diff; i++) {
                        data.shift();
                    }
                }



                let details = data.map((item) => {
                    // const showAmt = showAmtInvt * (interestRate / 100) * item;
                    // const totalAmt = showAmt + showAmtInvt;
                    let totalAmt;
                    let showPercent;
                    if (item > investmentPeriod) {
                        totalAmt = Math.round(compoundInterestMonth(
                            investmentAmount * 12,
                            interestRate,
                            investmentPeriod,
                            item
                        ));
                        showPercent = Math.round((totalAmt / showAmtRet) * 100);
                    } else {
                        totalAmt = Math.round(compoundInterestMonthSmall(
                            investmentAmount * 12,
                            interestRate,
                            item
                        ));
                        showPercent = Math.round((totalAmt / showAmtRet) * 100);
                    }

                    return {
                        item,
                        totalAmt,
                        showPercent,
                    };
                });
                setShowBar(details);
            } else if (paymentType === "yearly") {
                if (maturity <= 5) {
                    for (let i = 2; i <= maturity; i += 2) {
                        data.push(i);
                    }

                    if (!data.includes(maturity)) {
                        data.push(+maturity);
                    }
                } else if (maturity <= 10) {
                    for (let i = 3; i <= maturity; i += 3) {
                        data.push(i);
                    }

                    if (!data.includes(maturity)) {
                        data.push(+maturity);
                    }
                } else if (maturity < 20) {
                    for (let i = 4; i <= maturity; i += 4) {
                        data.push(i);
                    }

                    if (!data.includes(maturity)) {
                        data.push(+maturity);
                    }
                } else if (maturity >= 20) {
                    for (let i = 5; i <= maturity; i += 5) {
                        data.push(i);
                    }

                    if (!data.includes(+maturity)) {
                        data.push(+maturity);
                    }
                }

                if (data.length > 5) {
                    let diff = data.length - 5;
                    for (let i = 0; i < diff; i++) {
                        data.shift();
                    }
                }


                let details = data.map((item) => {
                    // const showAmt = showAmtInvt * (interestRate / 100) * item;
                    // const totalAmt = showAmt + showAmtInvt;
                    let totalAmt;
                    let showPercent;
                    if (item > investmentPeriod) {
                        totalAmt = Math.round(compoundInterestYear(
                            +investmentAmount,
                            interestRate,
                            investmentPeriod,
                            item
                        ));
                        showPercent = Math.round((totalAmt / showAmtRet) * 100);
                    } else {
                        totalAmt = Math.round(compoundInterestYearSmall(
                            +investmentAmount,
                            interestRate,
                            item
                        ));
                        showPercent = Math.round((totalAmt / showAmtRet) * 100);
                    }

                    return {
                        item,
                        totalAmt,
                        showPercent,
                    };
                });

                setShowBar(details);
            }
        }
    }, [showAmtInvt, showAmtRet]);



    /*Cost Of Delay Calculator*/

    const SIPCalculation = (targetAmount, targetYear, expectedReturn, DelayMonth) => {

        let var1 = targetAmount;
        let var2 = targetYear;
        let var3 = expectedReturn;
        let delayMonth = DelayMonth;

        let SIP = (var1 * (((1 + ((var3 / 100) / 12)) ** (var2 * 12)) - 1) * (1 + ((var3 / 100) / 12))) / ((var3 / 100) / 12);
        let expected_amount = Math.round(SIP);
        let amount_invested = Math.round(var1 * var2 * 12);
        let profit_earned = Math.round(SIP - (var1 * var2 * 12));
        setSIPValue(SIP);
        let CostDelay = (var1 * (((1 + ((var3 / 100) / 12)) ** ((var2 * 12) - delayMonth)) - 1) * (1 + ((var3 / 100) / 12))) / ((var3 / 100) / 12);
        setDelayAmount(CostDelay);

    }

    useEffect(() => {
        SIPCalculation(targetAmount, targetYear, expectedReturn, DelayMonth)
    }, [])


    const handleDelayMonth = (e) => {
        let delayMonth = e.target.value;
        if (delayMonth <= 50) {
            setDelayMonth(delayMonth)
            SIPCalculation(targetAmount, targetYear, expectedReturn, delayMonth);
        } else {
            setDelayMonth(50)
            SIPCalculation(targetAmount, targetYear, expectedReturn, 50);
        }
    }


    const handlePaymentType = (value) => {
        /*const { value } = e.target;*/
        const investAmount = parseInt(investmentAmount);
        const prevPaymentType = paymentType;
        switch (value) {
            case "yearly":
                setPaymentType("yearly");
                const yearlyInvAmt = paymentType == 'monthly' ? investAmount * 12 : paymentType == 'quarterly' ? investAmount * 4 : paymentType == 'halfyearly' ? investAmount * 2 : investAmount * 12;
                setInvestmentAmount(yearlyInvAmt);
                break;
            case "monthly":
                setPaymentType("monthly");
                const monthlyInvAmt = paymentType == 'yearly' ? investAmount / 12 : paymentType == 'quarterly' ? investAmount / 3 : paymentType == 'halfyearly' ? investAmount / 6 : investAmount / 12;
                setInvestmentAmount(monthlyInvAmt);
                break;
            case "quarterly":
                setPaymentType("quarterly");
                const quarterlyInvAmt = paymentType == 'yearly' ? investAmount / 4 : paymentType == 'monthly' ? investAmount * 3 : paymentType == 'halfyearly' ? investAmount / 2 : investAmount / 4;
                setInvestmentAmount(quarterlyInvAmt);
                break;
            case "halfyearly":
                setPaymentType("halfyearly");
                const halfyearlyInvAmt = paymentType == 'yearly' ? investAmount / 2 : paymentType == 'monthly' ? investAmount * 6 : paymentType == 'quarterly' ? investAmount * 2 : investAmount / 2;
                setInvestmentAmount(halfyearlyInvAmt);
                break;

            default:
                setPaymentType("monthly");
                setInvestmentAmount(investAmount * 12);
        }
    }

    useEffect(() => {
        const payFreq = props.QuoteReq?.PaymentFreq;
        setInvestmentAmount(props?.Quotes[0]?.ModelPremium || 10000);
        setInvestmentPeriod(props?.QuoteReq?.PaymentTerm);
        setMaturity(props?.QuoteReq?.PolicyTerm);
        setPaymentType(payFreq == "M" ? 'monthly' : payFreq == "Y" ? 'yearly' : payFreq == "H" ? 'halfyearly' : 'quarterly');
        setTargetYear(props?.QuoteReq?.PaymentTerm ? props?.QuoteReq?.PaymentTerm : 10);
        setTargetAmount(getTargetAmt());
    }, []);

    const getTargetAmt = () => {
        let targetAmt = 10000;
        const PFreq = props.QuoteReq?.PaymentFreq;
        const MPrem = parseInt(props?.Quotes[0]?.ModelPremium || 10000);
        if (MPrem && PFreq) {
            targetAmt = PFreq == "Y" ? MPrem / 12 : PFreq == "H" ? MPrem / 6 : PFreq == 'Q' ? MPrem / 3 : MPrem;
            targetAmt = Math.round(targetAmt);
        }
        return targetAmt;
    }

    return (
        
        <Tabs
            defaultActiveKey="investmentcalc"
            id="justify-tab-example"
            className="mb-3 calctabs"
            justify
        >
            <Tab eventKey="investmentcalc" title="Calculate by Investment Amount">
                <div className="Calculator InvestmentLoginPage">
                    <div className="CalculatorHead">
                        <h2>Calculate by Investment Amount</h2>
                        <button className="clsBtn" onClick={props.close}>
                            <img src={require("../../Investment/Cross.svg").default} alt="" />
                        </button>
                    </div>
                    <div id="invstmntcalc" className="row">
                        <div className="col-md-6">
                            <form onSubmit={handleSubmit}>
                                <div className="CalcForm">
                                    <label className="InLabel" htmlFor="investmentAmount">Your Investment Amount</label>
                                    <MaskedInput
                                        mask={[
                                            /[0-9]/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                        ]}
                                        guide={false}
                                        showMask={false}
                                        className="packageForm"
                                        value={CommaSeprator("₹" + Math.round(investmentAmount))}
                                        onChange={(e) => setInvestmentAmount(e.target.value)}
                                    />
                                    <span className="InvAmntSet">₹{convertIntoLakh(investmentAmount)}</span>
                                    <small class="Error-Text">{err}</small>
                                </div>

                                {/*<div className="CalcForm">
                                    <label className="labeltext">Payment Frequency</label>
                                    <div className="radio-item">
                                        <input
                                            type="radio"
                                            id="monthly"
                                            name="paymentType"
                                            value="monthly"
                                            checked={paymentType === "monthly"}
                                            onChange={() => { setPaymentType("monthly"); setInvestmentAmount(investmentAmount / 12) }}
                                        />

                                        <label htmlFor="monthly"></label>
                                        <span>Monthly</span>
                                    </div>
                                    <div className="radio-item">
                                        <input
                                            type="radio"
                                            id="yearly"
                                            name="paymentType"
                                            value="yearly"
                                            checked={paymentType === "yearly"}
                                            onChange={() => {
                                                setPaymentType("yearly");
                                                setInvestmentAmount(investmentAmount * 12);
                                            }
                                            }
                                        />
                                        <label htmlFor="yearly"></label>
                                        <span>Yearly</span>
                                    </div>
                                </div>*/}

                                <div className="CalcForm">
                                    <label className="InLabel">Payment Frequency</label>
                                 {/*   <select
                                        className="InvestSelect_PF"
                                        value={paymentType}
                                        onChange={handlePaymentType}
                                    >
                                        <option value="yearly">Yearly</option>
                                        <option value="monthly">Monthly</option>
                                        <option value="quarterly">Quarterly</option>
                                        <option value="halfyearly">Half Yearly</option>
                                    </select>*/}
                                    <CustomDropdown
                                        options={paymentFrequencyList}
                                        value={paymentType}
                                        labelKey="name"
                                        valueKey="code"
                                        placeholder="Select Payment Frequency"
                                        onChange={(data) => handlePaymentType(data.code)}
                                    />
                                </div>

                                <div className="CalcForm">
                                    <label className="InLabel" htmlFor="investmentPeriod">
                                        Investment Period
                                    </label>

                                    <MaskedInput
                                        mask={[
                                            /[0-9]/,
                                            /\d/,
                                        ]}
                                        guide={false}
                                        showMask={false}
                                        className="packageForm"
                                        value={investmentPeriod}
                                        onChange={(e) => setInvestmentPeriod(e.target.value)}
                                    />
                                    <span className="yearsSet">{!Year || investmentPeriod ? "years" : ""}</span>
                                    </div>
                                <div className="CalcForm">
                                    <label className="InLabel" htmlFor="maturity">Maturity After</label>
                                    <MaskedInput
                                        mask={[
                                            /[0-9]/,
                                            /\d/,
                                        ]}
                                        guide={false}
                                        showMask={false}
                                        className="packageForm"
                                        value={maturity}
                                        onChange={(e) => setMaturity(e.target.value)}
                                    />
                                    <span className="yearsSet">{!Year || maturity ? "years" : ""}</span>
                                    <small class="Error-Text">{error}</small>
                                </div>
                                <div className="CalcForm">
                                    <label className="InLabel" htmlFor="interestRate">Expected Interest Rate</label>
                                    <MaskedInput
                                        mask={[
                                            /[0-9]/,
                                            /\d/,
                                         ]}
                                        guide={false}
                                        showMask={false}
                                        className="packageForm"
                                        value={interestRate}
                                        onChange={(e) => setInterestRate(e.target.value)}
                                    />
                                    <span className="RateSet">{!Year || interestRate ? "%" : ""}</span>

                                    <input
                                        type="range"
                                        className="slider border-0  "
                                        min={1}
                                        max={25}
                                        step={1}
                                        value={interestRate}
                                        onChange={(e) => setInterestRate(e.target.value)}
                                    />
                                    <ul className="InterestRate">
                                        <li>1%</li>
                                        <li>5%</li>
                                        <li>10%</li>
                                        <li>15%</li>
                                        <li>20%</li>
                                        <li>25%</li>
                                    </ul>
                                </div>
                            </form>
                        </div>
                        <div className="col-md-6">
                            <div className="CalcAmtInvt">
                                <ShowInvestment
                                    showTxt="YOUR INVESTMENT"
                                    showAmt={showAmtInvt}
                                    showYrs={`in ${investmentPeriod} years`}
                                />
                                <ShowInvestment
                                    showTxt="YOUR RETURN"
                                    showAmt={showAmtRet}
                                    showYrs={`in ${maturity} years`}
                                />
                            </div>
                            <div className="BarGraph">
                                {showBar &&
                                    showBar.slice().reverse().map((data) => (
                                        <BarGraph
                                            year={data.item}
                                            percent={data.showPercent}
                                            amt={data.totalAmt}
                                        />
                                    ))}
                            </div>
                        </div>
                    </div>


                    <small className="Disclaimer">
                        <i>
                            Disclaimer: The figures presented here are solely for demonstrative purposes. The outcomes are computed using the provided information and should not be considered as the sole basis for making investment decisions.
                            <br />
                            <br />
                            * Valid for guaranteed return plans
                        </i>
                    </small>

                    {/* {showBar && showBar.map(data => (
         <BarGraph year={data.item} percent={data.showPercent} amt={data.totalAmt} />

      ))} */}

                </div>
            </Tab>

            <Tab eventKey="goalamountcalc" title="Calculate by Goal Amount">
                <GoalCalc onc={props.close} investmentPeriod={investmentPeriod} maturity={maturity} />
            </Tab>

            <Tab eventKey="costdelaycalc" title="Calculate Cost of Delay">
                <div className="Calculator InvestmentLoginPage">
                    <div className="CalculatorHead">
                        <h2>Calculate Cost of Delay</h2>
                        <button className="clsBtn" onClick={props.close}>
                            <img src={require("../../Investment/Cross.svg").default} alt="" />
                        </button>
                    </div>
                    <div id="invstmntcalc" className="row">
                        <div className="col-md-6">
                            <form onSubmit={handleSubmit}>
                                <div className="CalcForm">
                                    <label className="InLabel" htmlFor="investmentAmount">Monthly SIP Amount</label>
                                    <MaskedInput
                                        mask={[
                                            /[0-9]/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                        ]}
                                        guide={false}
                                        showMask={false}
                                        className="packageForm"
                                        value={CommaSeprator("₹" + targetAmount)}
                                        onChange={(e) => { setTargetAmount(e.target.value); SIPCalculation(e.target.value, targetYear, expectedReturn, DelayMonth); }}
                                    />
                                    <span className="InvAmntSet">₹{convertIntoLakh(targetAmount)}</span>
                                </div>

                                <div className="CalcForm">
                                    <label className="InLabel" htmlFor="investmentPeriod">
                                        Investment Period
                                    </label>

                                    <MaskedInput
                                        mask={[
                                            /[0-9]/,
                                            /\d/,
                                        ]}
                                        guide={false}
                                        showMask={false}
                                        className="packageForm"
                                        value={targetYear}
                                        onChange={(e) => { setTargetYear(e.target.value); SIPCalculation(targetAmount, e.target.value, expectedReturn, DelayMonth) }}
                                        onBlur={() => setYear(false)}
                                        onFocus={() => setYear(true)}
                                    />
                                    <span className="yearsSet">{!Year || targetYear ? "years" : ""}</span>
                                </div>

                                <div className="CalcForm">
                                    <label className="InLabel" htmlFor="interestRate">Expected Interest Rate</label>
                                    <MaskedInput
                                        mask={[
                                            /[0-9]/,
                                            /\d/,
                                         ]}
                                        guide={false}
                                        showMask={false}
                                        className="packageForm"
                                        value={expectedReturn}
                                        onChange={(e) => { setExpectedReturn(e.target.value); SIPCalculation(targetAmount, targetYear, e.target.value, DelayMonth) }}
                                    />
                                    <span className="RateSet">{!Year || expectedReturn ? "%" : ""}</span>

                                    <input
                                        type="range"
                                        className="slider border-0"
                                        min={1}
                                        max={30}
                                        step={1}
                                        value={expectedReturn}
                                        onChange={(e) => { setExpectedReturn(e.target.value); SIPCalculation(targetAmount, targetYear, e.target.value, DelayMonth) }}
                                    />
                                    <ul className="InterestRate SIPdelaymonth">
                                        <li>1%</li>
                                        <li>5%</li>
                                        <li>10%</li>
                                        <li>15%</li>
                                        <li>20%</li>
                                        <li>25%</li>
                                        <li>30%</li>
                                    </ul>
                                </div>

                                <div className="CalcForm">
                                    <label className="InLabel" htmlFor="maturity">SIP Delay (in Months)</label>
                                    <MaskedInput
                                        mask={[
                                            /[0-9]/,
                                            /\d/,


                                        ]}
                                        guide={false}
                                        showMask={false}
                                        className="packageForm"
                                        value={DelayMonth}
                                        onChange={(e) => handleDelayMonth(e)}
                                    />
                                    <span className="yearsSet">{!Year || DelayMonth ? "months" : ""}</span>
                                    <small class="Error-Text">{error}</small>
                                </div>

                            </form>
                        </div>
                        <div className="col-md-6">


                            <div className="CalcAmtInvt costofdelay">
                                <div className='CODbox'>
                                    <p>As a result of a <strong>{DelayMonth} months delay</strong>, your targeted wealth will decrease by <strong>{(((SIPValue - DelayAmount) / SIPValue) * 100).toFixed(2)}%</strong>, resulting in a loss of <strong>₹{CommaSeprator(Math.round(SIPValue - DelayAmount))}</strong></p>
                                </div>
                            </div>
                            <div className="BarGraph COD">
                                <BarGraphCostOfDelay
                                    year={targetYear}
                                    percent={Math.round((SIPValue / SIPValue) * 100)}
                                    amt={SIPValue}
                                    Msg="If you start investing today"
                                    IsDelayGraph={false}
                                />
                                <BarGraphCostOfDelay
                                    year={targetYear}
                                    percent={Math.round((DelayAmount / SIPValue) * 100)}
                                    amt={DelayAmount}
                                    Msg={`If you start with of delay ${DelayMonth} months`}
                                    IsDelayGraph={true}
                                />
                            </div>
                        </div>
                    </div>


                    <small className="Disclaimer">
                        <i>
                            Disclaimer: The figures presented here are solely for demonstrative purposes. The outcomes are computed using the provided information and should not be considered as the sole basis for making investment decisions.
                        </i>
                    </small>

                    {/* {showBar && showBar.map(data => (
         <BarGraph year={data.item} percent={data.showPercent} amt={data.totalAmt} />

      ))} */}

                </div>
            </Tab>
        </Tabs>
    );
};

export default Calculator;
